<template>
    <div class="col-12" :class="brakingPoints" >
        <div class="card border-radius-8 shadow mb-5">
            <div class="card-body" :class="card_padding">
                <slot />
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        size: {
            type: String,
            default: ''
        },
        card_padding: {
            type: String,
            default:'p-0',
        },
    },

    computed: {
        brakingPoints: function () {
            switch (this.size) {
                case 'small':
                    return `col-md-4`;
                case 'medium':
                    return `col-md-6`;
                case 'large':
                    return `col-md-8`;
                default:
                    return this.size;
            }
        },
    },
}

</script>
